import api from './api';
import { Subscriber } from '../types';

export const subscriberApi = {
    getSubscribersByEntityConfigId: async (entityConfigId: string) => {
        const response = await api.get(`/admin/subscribers/entity-config/${entityConfigId}`);
        return response.data;
    },

    createSubscriber: async (subscriber: Partial<Subscriber>) => {
        const response = await api.post('/admin/subscribers', subscriber);
        return response.data;
    },

    updateSubscriber: async (id: string, subscriber: Partial<Subscriber>) => {
        const response = await api.put(`/admin/subscribers/${id}`, subscriber);
        return response.data;
    },

    deleteSubscriber: async (id: string) => {
        await api.delete(`/admin/subscribers/${id}`);
    }
};
